import React from "react";
import { Text, Flex } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import * as styles from "./styles_vanilla.css";

const ModernTreasuryProviderStatus: React.FC = () => {
  return (
    <div className={styles.providerStatusSection}>
      <Flex flexDirection="column" gap={Sizes.SM}>
        <Text variant="strong-md">Modern Treasury Provider Status</Text>
        <Text variant="regular-sm">Modern Treasury monitoring not yet implemented</Text>
      </Flex>
    </div>
  );
};

export default ModernTreasuryProviderStatus;
export { ModernTreasuryProviderStatus };
